import { MovableUITheme } from '@movable/ui';
import { Theme } from '@mui/material';

declare module '@mui/material/styles' {
  interface Theme {
    primaryNav: {
      navOpenWidth: string;
      navClosedWidth: string;
      smallNavClosedWidth: string;
      backgroundColor: string;
      hoverBackgroundColor: string;
      activeBackgrounColor: string;
      itemBorderRadius: string;
    };
  }
  interface PaletteColor {}
  interface Palette {}
  interface PalletteOptions {}
}
declare module '@mui/material/Chip' {
  interface ChipPropsVariantOverrides {
    contrastFilled: true;
  }
}

const textFieldRootShareStyling =
  MovableUITheme.components?.MuiTextField?.styleOverrides?.root;

export default {
  primaryNav: {
    navOpenWidth: '320px',
    navClosedWidth: '64px',
    smallNavClosedWidth: '57px',
    backgroundColor: '#162229',
    hoverBackgroundColor: '#1C2E37',
    activeBackgrounColor: '#113650',
    itemBorderRadius: '6px',
  },
  components: {
    MuiCheckbox: {
      defaultProps: {
        disableRipple: true,
      },
      styleOverrides: {
        //TODO: remove this styling once we update movable/ui package version since it will come from there.
        root: ({ theme }: { theme: Theme }) => ({
          '&.Mui-disabled': {
            color: theme.palette.neutral500,
          },
          '&.MuiCheckbox-root.MuiCheckbox-sizeSmall + .MuiFormControlLabel-label':
            {
              fontSize: theme.typography.body2.fontSize,
            },
        }),
      },
    },
    MuiTextField: {
      styleOverrides: {
        '.MuiInputAdornment-positionStart': {
          marginTop: '2px !important',
        },
        ...(textFieldRootShareStyling && {
          root: textFieldRootShareStyling,
          '& .MuiInputLabel-root': {
            paddingBottom: 1,
          },
        }),
      },
    },
    MuiSelect: {
      styleOverrides: {
        fieldset: {
          borderColor: 'transparent !important',
        },
      },
    },
    MuiDataGrid: {
      styleOverrides: {
        root: {
          '.MuiDataGrid-overlayWrapper': {
            height: 'auto',
          },
        },
        menu: {
          '.MuiPaper-root': {
            padding: '0px', // Update the padding as per your requirement
          },
        },
      },
    },
    MuiAccordion: {
      defaultProps: {
        variant: 'elevation',
      },
      styleOverrides: {
        root: {
          padding: '0px',
        },
      },
    },
    MuiMenu: {
      styleOverrides: {
        padding: '0px',
      },
    },
    MuiPopover: {
      styleOverrides: {
        paper: {
          padding: 0,
        },
      },
    },
  },
  palette: {},
} as const;
